import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import router from './router/router'
import store from './store/store'
import './style/element-variables.scss'
import { post, get, patch, put, deleteData, postFormData, postJson } from './api/http/http'
import Pagination from 'vue-pagination-2'
import pages from './components/pages'
import './assets/icon/iconfont.css'
import viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueDND from 'awe-dnd'
import TimePipe from './config/timePipe.js'
import { message } from './config/resetMessage.js'
import './assets/icon-fount/iconfont.css'
import VueQuillEditor from 'vue-quill-editor' // 富文本编辑器
import 'quill/dist/quill.core.css' // 富文本编辑器的样式
import 'quill/dist/quill.snow.css' // 富文本编辑器的样式
import 'quill/dist/quill.bubble.css' // 富文本编辑器的样式
import FullCalendar from 'vue-full-calendar'
import VueQr from 'vue-qr' // 二维码工具
import draggable from 'vuedraggable' // 可拖拽元素组件
// 多语言
import VueI18n from 'vue-i18n'

// 定义http请求的全局变量
Vue.prototype.$post = post
Vue.prototype.$postJson = postJson
Vue.prototype.$postFormData = postFormData
Vue.prototype.$get = get
Vue.prototype.$patch = patch
Vue.prototype.$put = put
Vue.prototype.$delete = deleteData
Vue.config.productionTip = false
Vue.directive('loadmore', { // 下拉框实现动态滚动
  bind(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTWRAP_DOM.addEventListener('scroll', function() {
        const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
        if (CONDITION) {
            binding.value()
        }
    })
  }
})
Vue.use(ElementUI)
Vue.use(VueQuillEditor)
Vue.use(FullCalendar)
Vue.use(VueI18n) // 通过插件的形式挂载
Vue.use(VueQr)
Vue.use(draggable)
Vue.component('pagination', Pagination)
Vue.component('pages', pages)
Vue.use(viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
// 重写message提示框
Vue.prototype.$message = message 
// 路由onError断网处理
router.onError((error) => {
  if (error.name === 'ChunkLoadError') {
    // Vue.prototype.$message.error(this.$i18n.t('lang.warning_network'))
    Vue.prototype.$message.error('服务连接超时，请检查你的网络连接')
  }
})
Vue.use(VueDND)
Vue.filter(TimePipe)
const i18n = new VueI18n({
  locale: 'zh-CN',
  messages: {
    'zh-CN': require('./common/lang/zh'), // 中文语言包
    'en-US': require('./common/lang/en') // 英文语言包
  }
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
